import React, { useState, useEffect } from "react";

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavLink,
} from "reactstrap";

import logo from "../assets/img/logo.png";

import CallToAction from "./CallToAction";

import dataProvider from "../services/DataProvider";

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const [acesso, setAcesso] = useState({});

  useEffect(() => {
    dataProvider.getAll("WsSanEndPoints.rule?sys=SAS").then((response) => {
      if (typeof response.data !== "undefined") {
        setAcesso(response.data.acesso);
      }
    });
  }, []);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <Navbar color="primary" light expand="md">
      <NavbarBrand href="/">
        <img
          src={logo}
          className="img-nav"
          alt="SIMSAN"
          style={{ width: 210, marginLeft: 40 }}
        ></img>
      </NavbarBrand>

      {/*<CallToAction/>*/}

      <NavbarToggler onClick={toggle} />
      <Collapse isOpen={isOpen} navbar>
        <Nav className="ml-auto" navbar >
          <NavLink className="btn-acesso" href={acesso} >
          Acesso Servidor Público
            
          </NavLink>
        </Nav>
      </Collapse>
    </Navbar>
  );
};

export default NavBar;
